export default __webpack_public_path__ + "static/media/wrong.f8b4c050.svg";